import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@chakra-ui/react";
import Duck from "./DuckSVG";

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  return <Button variant="outline" colorScheme="yellow" onClick={() => loginWithRedirect()}>Log In</Button>;
};

export default LoginButton;